import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcMask from '@/components/Mask.vue';
// @ts-ignore
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
// import { watch } from 'vue';
let MaintainPlan = class MaintainPlan extends Vue {
    constructor(props) {
        super(props);
        this.tableProp = {
            headers: [],
            desserts: [],
            isDetail: true,
            key: 'id',
            perPage: '',
        }; // 表格配置项
        this.deviceList = []; // 存在医院关系的设备集合
        this.snackbar = new CBcSnackbar();
        this.planInfoDlg = new CBcDialog(new CBcDialogForm());
        this.deviceInList = [];
        this.searchOptions = {
            deviceType: '',
            quickly: '',
            bindingType: 0,
            deviceMode: '',
            timer: null,
            nextMaintainTimeRange: [],
        };
        this.pageLoading = false;
        this.notPlanDevice = [];
        this.suggest = {
            isShow: false,
            deviceId: 0,
            result: {},
        };
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        // 设备状态
        this.deviceState = [
            { name: '全部', value: 0 },
            { name: '正常使用', value: 1 },
            { name: '停用', value: 2 },
        ];
        this.menuInfo = [
            { text: '所有数据', value: 0 },
            { text: '全部预警', value: 1 },
        ];
        // 变量在构造函数内部进行声名赋值
        const that = this;
        that.tableProp.headers = [
            {
                text: '发送/使用地点',
                align: 'left',
                sortable: true,
                value: 'hospitalName',
                width: '170',
            },
            {
                text: '设备型号',
                align: 'center',
                sortable: true,
                value: 'mode',
                width: '120',
            },
            {
                text: '机器编号',
                align: 'center',
                sortable: false,
                value: 'deviceNo',
            },
            {
                text: '设备负责人',
                align: 'center',
                sortable: false,
                value: 'manager',
                width: '80',
            },
            {
                text: '是否使用',
                align: 'center',
                sortable: false,
                value: 'isUse',
            },
            {
                text: '上次维护日期',
                align: 'center',
                sortable: false,
                value: 'lastMaintainTime',
                width: '115',
            },
            {
                text: '预计维护日期',
                align: 'center',
                sortable: true,
                value: 'nextMaintainTime',
                width: '125',
            },
            // {
            //   text: '固定维护日期',
            //   align: 'center',
            //   sortable: false,
            //   value: 'fixMaintainTime',
            //   width: '115',
            // },
            {
                text: '维护周期（天）',
                align: 'start',
                sortable: false,
                value: 'period',
                width: '90',
            },
            {
                text: '有效剩余（天）',
                align: 'start',
                sortable: true,
                value: 'validDay',
                width: '90',
            },
            {
                text: '上次维护后累积数(瓶/次)',
                align: 'start',
                sortable: false,
                value: 'lastMaintainBottles',
                width: '130',
            },
            {
                text: '平均日业务量（瓶/次）',
                align: 'start',
                sortable: false,
                value: 'averageDayDispense',
                width: '110',
            },
            {
                text: '往期月业务量（瓶/次）',
                align: 'start',
                sortable: false,
                value: 'pastMonthDispense',
                width: '110',
            },
            // {
            //   text: '有效剩余量（%）',
            //   align: 'center',
            //   sortable: false,
            //   value: 'validBottles',
            //   width: '110',
            // },
            {
                text: '保养数（瓶/次）',
                align: 'start',
                sortable: false,
                value: 'maintainBottles',
                width: '90',
            },
            {
                text: '操作',
                align: 'center',
                sortable: false,
                value: 'action',
                width: '140',
            },
        ];
        that.tableProp.desserts = [];
        that.rules = {
            require: (value) => {
                if (!value || (!value && !value.replace(/\s+/g, ''))) {
                    return '该参数为必填项！';
                }
                return true;
            },
        };
        that.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
        };
        that.maskValue = {
            isShow: false,
        };
    }
    // 取url参数信息
    get routeQuery() {
        const that = this;
        return that.$router.currentRoute.query || {};
    }
    get deviceNoValue() {
        const that = this;
        return that.routeQuery.deviceNo;
    }
    get deviceModeValue() {
        const that = this;
        return that.routeQuery.deviceMode;
    }
    get nextMaintainTimeRange() {
        const that = this;
        if (that.searchOptions.nextMaintainTimeRange && that.searchOptions.nextMaintainTimeRange.length > 1) {
            if (that.searchOptions.nextMaintainTimeRange[0] > that.searchOptions.nextMaintainTimeRange[1]) {
                const t = that.searchOptions.nextMaintainTimeRange[0];
                that.searchOptions.nextMaintainTimeRange[0] = that.searchOptions.nextMaintainTimeRange[1];
                that.searchOptions.nextMaintainTimeRange[1] = t;
            }
        }
        return (that.searchOptions.nextMaintainTimeRange && that.searchOptions.nextMaintainTimeRange.join(' ~ ')) || '';
    }
    set nextMaintainTimeRange(val) {
        const that = this;
        if (val) {
            that.searchOptions.nextMaintainTimeRange = val.split(',');
        }
        else {
            that.searchOptions.nextMaintainTimeRange = [];
        }
    }
    mounted() {
        const that = this;
        if (that.deviceNoValue) {
            that.searchOptions.quickly = that.deviceNoValue;
        }
        if (that.deviceModeValue) {
            that.searchOptions.deviceMode = that.deviceModeValue;
        }
        that.setDeviceList();
        that.setDataList();
        that.initUserList();
    }
    async getDataList() {
        const that = this;
        const queryParams = {
            page: that.pagination.pageNow,
            limit: typeof that.pagination.everyPageCount === 'number' ? that.pagination.everyPageCount : 1000,
            quickly: that.searchOptions.quickly || '',
            deviceMode: that.searchOptions.deviceMode || '',
            // 以下部分在手机端中无效
            startDate: '',
            endDate: '',
            deviceOnState: '',
            earlyWarning: 0,
            manager: that.searchOptions.manager || '',
        };
        // web端生效
        if (!/^xs$|^sm$/i.test(that.$vuetify.breakpoint.name)) {
            if (that.searchOptions.nextMaintainTimeRange) {
                queryParams.startDate = that.searchOptions.nextMaintainTimeRange[0] || '';
                queryParams.endDate = that.searchOptions.nextMaintainTimeRange[1] || '';
            }
            queryParams.deviceOnState = that.searchOptions.deviceOnState || '';
            queryParams.earlyWarning = that.searchOptions.earlyWarning || 0;
        }
        let result = await that.axios.get('/api/device/maintain', { params: queryParams });
        if (!result || !(result.status === 200)) {
            // 数据解析和计算
            result = { data: { sum: 0, result: [] } };
        }
        // 分页信息处理
        that.pagination.sumDetail = result.data.sum;
        const pageCount = Math.ceil(result.data.sum / that.pagination.everyPageCount) || 1;
        that.pagination.pageCount = pageCount;
        return result;
    }
    async setDataList() {
        const that = this;
        try {
            const res = await that.getDataList();
            // 转换返回值
            const resultData = [];
            res.data.result.forEach((o) => {
                const model = {
                    id: o.planId,
                    rId: o.rId,
                    deviceId: o.deviceId,
                    lastMaintainTime: that.dateFormat(o.lastMaintainTime),
                    // fixMaintainTime: that.dateFormat(o.fixMaintainTime),
                    fixMaintainDay: o.fixMaintainDay,
                    lastMaintainBottles: o.lastMaintainBottles,
                    pastMonthDispense: o.pastMonthDispense,
                    averageDayDispense: o.averageDayDispense,
                    maintainBottles: o.maintainBottles,
                    dayWarningValue: o.dayWarningValue,
                    bottleWarningValue: o.bottleWarningValue,
                    remark: o.remark,
                    deviceName: o.deviceName,
                    deviceNo: o.deviceNo,
                    hospitalId: o.hospitalId,
                    hospitalName: o.hospitalName,
                    dept: o.dept,
                    onState: o.onState,
                    type: o.type,
                    mode: o.mode,
                    manager: o.manager,
                    validBottles: o.validBottles,
                    period: o.period,
                    nextMaintainTime: (o.nextMaintainTime && that.dateFormat(o.nextMaintainTime)) || '',
                    validDay: o.validDay,
                    deliveryDate: that.dateFormat(o.deliveryDate),
                };
                // 计算一些值
                // 是否使用
                model['isUse'] = /使用|临床/.test(model['onState']) ? '是' : '否';
                model['deviceIsUse'] = /使用|临床/.test(model['onState']);
                // 有效剩余瓶 = (保养瓶数-累积使用瓶)/保养瓶数*100%
                // model['validBottles'] = (o.maintainBottles && o.maintainBottles > 0 ? (o.maintainBottles - o.lastMaintainBottles) / o.maintainBottles * 100 : 0).toFixed(2);
                if (/否/.test(model['isUse'])) {
                    model['period'] = '停用';
                    model['nextMaintainTime'] = '停用';
                    model['validDay'] = '停用';
                }
                else {
                    // // 维护周期= (预计下次维护时间 - 上次维护时间)
                    // model['period'] = (o.averageDayDispense > 0 ? ((o.maintainBottles - o.lastMaintainBottles) / o.averageDayDispense) : 0).toFixed(2);
                    // // 预计下次维护时间 = 当前时间  + ((保养瓶数 - 累积使用瓶数) / 平均每天使用量)
                    // model['nextMaintainTime'] = that.dateFormat(that.addDay(model['period'], new Date(`${model.lastMaintainTime}`)));
                    // // 有效剩余天数 = 预计下次维护时间 - 当前时间
                    // model['validDay'] = ((new Date(model['nextMaintainTime']).getTime() - new Date().getTime()) / 3600000 / 24).toFixed(2);
                }
                resultData.push(model);
            });
            that.tableProp.desserts = resultData;
        }
        catch (e) {
            console.log('setDataList error:', e);
        }
    }
    dateFormat(dateStr, format = 'yyyy-MM-dd') {
        if (dateStr) {
            return Vue.filter('dateFormat')(dateStr, format);
        }
        return dateStr;
    }
    addDay(dayNumber, date) {
        date = date || new Date();
        const ms = dayNumber * (1000 * 60 * 60 * 24);
        const newDate = new Date(date.getTime() + ms);
        return newDate;
    }
    async setDeviceList() {
        const that = this;
        const res = await that.axios.get('/api/device/maintain/situation');
        that.deviceList = (res && res.data && res.data.result) || [];
    }
    async showPlanInfoDlg(type, data) {
        const that = this;
        that.suggest.isShow = false;
        that.planInfoDlg.type = type;
        that.planInfoDlg.title = (type === 'add' ? '新增' : type === 'edit' ? '编辑' : '删除') + '设备维护计划';
        if (that.planInfoDlg.isCreateType) {
            that.planInfoDlg.form = new CBcDialogForm({
                deviceId: '',
                hospitalId: '',
                lastMaintainTime: new Date().toLocaleDateString().replace(/\//g, '-'),
                averageDayDispense: '300',
                lastMaintainBottles: '0',
                pastMonthDispense: '10',
                maintainBottles: '0',
                dayWarningValue: 15,
                bottleWarningValue: 20,
                remark: '',
                manager: '',
            });
        }
        else if (that.planInfoDlg.isEditType || that.planInfoDlg.isDeleteType) {
            that.planInfoDlg.form = new CBcDialogForm({
                id: data.id,
                rId: data.rId,
                hospitalId: data.hospitalId,
                deviceId: data.deviceId,
                lastMaintainTime: data.lastMaintainTime,
                averageDayDispense: data.averageDayDispense,
                lastMaintainBottles: data.lastMaintainBottles,
                pastMonthDispense: data.pastMonthDispense,
                maintainBottles: data.maintainBottles,
                dayWarningValue: data.dayWarningValue,
                bottleWarningValue: data.bottleWarningValue,
                remark: data.remark,
                deviceName: data.deviceName,
                deviceNo: data.deviceNo,
                manager: data.manager,
            });
            that.setSuggest();
        }
        else if (type === 'relieve') {
            console.log(data);
            that.planInfoDlg.title = '解除医院设备关系';
            that.planInfoDlg.form = new CBcDialogForm({ ...data });
        }
        that.planInfoDlg.visible = true;
    }
    async dialogPlanInfoSave() {
        const that = this;
        let handleName = (that.planInfoDlg.isCreateType ? '新增' : that.planInfoDlg.isEditType ? '编辑' : '删除') + '设备维护计划';
        that.planInfoDlg.loading = true;
        that.planInfoDlg.autoClose = false;
        if (that.planInfoDlg.type === 'relieve') {
            handleName = '解除医院设备关系';
            const dUrl = '/api/hospital/' + that.planInfoDlg.form.hospitalId + '/device/' + that.planInfoDlg.form.rId;
            await that.axios
                .delete(dUrl)
                .then((r) => {
                that.snackbar.success(`${handleName}成功！`);
                that.planInfoDlg.visible = false;
                that.setDataList();
            })
                .catch((e) => {
                that.snackbar.error(`${handleName}失败，原因：` + (e && (e.info || e.result || e.error)));
            });
            that.planInfoDlg.loading = false;
            that.planInfoDlg.autoClose = true;
            return;
        }
        if (!that.planInfoDlg.form.hospitalId) {
            that.snackbar.error('医院不能为空，请先选择医院！');
            that.planInfoDlg.loading = false;
            return false;
        }
        if (!that.planInfoDlg.form.deviceId) {
            that.snackbar.error('设备不能为空，请先选择设备！');
            that.planInfoDlg.loading = false;
            return false;
        }
        if (!that.planInfoDlg.form.maintainBottles || that.planInfoDlg.form.maintainBottles === 0) {
            that.snackbar.error('保养瓶数不得小于1瓶！');
            that.planInfoDlg.loading = false;
            return false;
        }
        if (!that.planInfoDlg.form.averageDayDispense || that.planInfoDlg.form.averageDayDispense === 0) {
            that.snackbar.error('平均日配药量不得小于1瓶！');
            that.planInfoDlg.loading = false;
            return false;
        }
        that.planInfoDlg.form.lastMaintainBottles = that.planInfoDlg.form.lastMaintainBottles || 0;
        that.planInfoDlg.form.pastMonthDispense = that.planInfoDlg.form.pastMonthDispense || 0;
        that.planInfoDlg.form.dayWarningValue = that.planInfoDlg.form.dayWarningValue || 15;
        that.planInfoDlg.form.bottleWarningValue = that.planInfoDlg.form.bottleWarningValue || 20;
        try {
            that.planInfoDlg.autoClose = true;
            if (that.planInfoDlg.isDeleteType) {
                await that.axios.delete(`/api/device/maintain/${that.planInfoDlg.form.id}`);
            }
            else {
                // 读取医院id
                const device = that.deviceList.find((o) => o.deviceId === that.planInfoDlg.form.deviceId);
                that.planInfoDlg.form.hospitalId = device.hospitalId;
                that.planInfoDlg.form.rId = device.rId;
                that.planInfoDlg.form.maintainBottles = Number(that.planInfoDlg.form.maintainBottles || 0).toFixed(2);
                that.planInfoDlg.form.averageDayDispense = Number(that.planInfoDlg.form.averageDayDispense || 0).toFixed(2);
                that.planInfoDlg.form.pastMonthDispense = Number(that.planInfoDlg.form.pastMonthDispense || 0).toFixed(2);
                if (that.planInfoDlg.isEditType)
                    await that.axios.put(`/api/device/maintain/${that.planInfoDlg.form.id}`, that.planInfoDlg.form);
                else if (that.planInfoDlg.isCreateType) {
                    await that.axios.post('/api/device/maintain', that.planInfoDlg.form);
                    device.isUse = 1;
                }
            }
            that.planInfoDlg.loading = false;
            that.snackbar.success(`${handleName}成功！`);
            that.setDataList();
            if (that.planInfoDlg.isEditType || that.planInfoDlg.isDeleteType) {
                that.setDeviceList();
            }
        }
        catch (e) {
            that.planInfoDlg.loading = false;
            that.planInfoDlg.visible = true;
            // TODO: dialog处理失败后不应close对话框
            that.snackbar.error(`${handleName}过程出错:` + (e && (e.info || e.result || e.error)));
        }
    }
    async getDeployInfo() {
        const that = this;
        const res = await that.axios.get('/api/device/maintain/static/dispen', {
            params: { deviceId: that.planInfoDlg.form.deviceId, date: that.planInfoDlg.form.lastMaintainTime },
        });
        return res;
    }
    onDialogLastMaintainTimeChanged(v, o) {
        const that = this;
        if (v === o || !v || !that.planInfoDlg.form.deviceId)
            return;
        that.setSuggest();
    }
    async setSuggest() {
        const that = this;
        if (!that.planInfoDlg.form.deviceId) {
            that.suggest.isShow = false;
            that.planInfoDlg.form.manager = '';
            return;
        }
        const device = that.deviceList.find((o) => o.deviceId === that.planInfoDlg.form.deviceId);
        if (that.planInfoDlg.isCreateType && device) {
            // 根据设备类型设置默认保养瓶数
            let bottle = 20000; // 默认值
            const deviceType = device.type || '';
            if (/安瓿/i.test(deviceType)) {
                // 安瓿机：10000瓶
                bottle = 10000;
            }
            else if (/西林/i.test(deviceType)) {
                // 西林机：20000瓶
                bottle = 20000;
            }
            else if (/多功能/i.test(deviceType)) {
                // 多功能机：20000瓶
                bottle = 20000;
            }
            else if (/预溶/i.test(deviceType)) {
                // 预溶仪：80000瓶
                bottle = 80000;
            }
            else if (/洗消/i.test(deviceType)) {
                // 洗消机：1000次
                bottle = 1000;
            }
            that.planInfoDlg.form.maintainBottles = bottle;
        }
        that.planInfoDlg.form.manager = device.manager;
        that.planInfoDlg.loading = true;
        const res = await that.getDeployInfo();
        if (res && res.data && res.data.result) {
            that.suggest.isShow = true;
            that.suggest.deviceId = that.planInfoDlg.form.deviceId;
            that.suggest.result = {
                cutBusineTotal: Number(res.data.result.cutBusineTotal || 0),
                dayBusineTotal: Number(res.data.result.dayBusineTotal || 0),
                monthBusineTotal: Number(res.data.result.monthBusineTotal || 0),
            };
        }
        else {
            that.suggest.isShow = false;
        }
        that.planInfoDlg.loading = false;
    }
    suggestClick() {
        const that = this;
        that.planInfoDlg.form.averageDayDispense = that.suggest.result.dayBusineTotal;
        that.planInfoDlg.form.lastMaintainBottles = that.suggest.result.cutBusineTotal;
        that.planInfoDlg.form.pastMonthDispense = that.suggest.result.monthBusineTotal;
    }
    /**
     * 医院切换
     */
    hospitalChange(event) {
        const that = this;
        // 清空设备id
        that.planInfoDlg.form.deviceId = '';
        // 隐藏掉参考值
        that.setSuggest();
    }
    /**
     * 设备切换
     */
    async deviceChange(event) {
        const that = this;
        // 如果是新增模式，选择设备后立即根据设备类型设置默认保养瓶数
        if (that.planInfoDlg.isCreateType && event) {
            const device = that.deviceList.find((o) => o.deviceId === event);
            if (device) {
                // 根据设备类型设置默认保养瓶数
                let bottle = 20000; // 默认值
                const deviceType = device.type || '';
                if (/安瓿/i.test(deviceType)) {
                    // 安瓿机：10000瓶
                    bottle = 10000;
                }
                else if (/西林/i.test(deviceType)) {
                    // 西林机：20000瓶
                    bottle = 20000;
                }
                else if (/多功能/i.test(deviceType)) {
                    // 多功能机：20000瓶
                    bottle = 20000;
                }
                else if (/预溶/i.test(deviceType)) {
                    // 预溶仪：80000瓶
                    bottle = 80000;
                }
                else if (/洗消/i.test(deviceType)) {
                    // 洗消机：1000次
                    bottle = 1000;
                }
                that.planInfoDlg.form.maintainBottles = bottle;
            }
        }
        // 如果已有维护日期，则调用 setSuggest 获取其他建议值
        if (that.planInfoDlg.form.lastMaintainTime && that.suggest.deviceId !== event) {
            that.setSuggest();
        }
    }
    dialogInfoClose() {
        const that = this;
        that.planInfoDlg.visible = false;
    }
    deviceTypeChange(value) {
        const that = this;
        if (!that.searchOptions.oldDeviceType) {
            that.searchOptions.oldDeviceType = value;
        }
        else if (that.searchOptions.oldDeviceType !== value) {
            that.searchOptions.oldDeviceType = value;
            that.searchOptions.deviceMode = null;
            that.searchChange();
        }
    }
    searchChange() {
        const that = this;
        that.pagination.pageNow = 1;
        clearTimeout(that.searchOptions.timer);
        that.searchOptions.timer = setTimeout(() => {
            that.setDataList();
        }, 1000); // 1秒执行一次获取函数 防抖
    }
    searchKeydown() {
        const that = this;
        that.searchChange();
    }
    async linkToHosptail(id, isOpenPersonnelPanels) {
        const that = this;
        if (id)
            that.$router.push({ name: 'HospitalInfo', params: { id: id, isOpenPersonnelPanels: isOpenPersonnelPanels } });
    }
    menuChange(option) {
        const that = this;
        that.searchOptions.earlyWarning = option.value;
        that.searchOptions.deviceOnState = option.value > 0 ? 1 : '';
        that.searchChange();
    }
    deviceFilter(item, queryText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['deviceNo'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['deviceName'].toUpperCase()));
    }
    /**
     * 列表操作设备使用状态
     * @param item
     */
    deviceIsUseChange(item) {
        const that = this;
        const dUrl = '/api/hospital/' + item.hospitalId + '/device';
        const iBody = {
            // rId就是 t_r_device_hospital 设备与医院关系表id
            id: item.rId,
            onState: item.deviceIsUse ? '正常使用' : '停用',
        };
        that.axios
            .put(dUrl, iBody)
            .then((res) => {
            that.snackbar.success('设备状态修改成功');
            that.searchChange();
        })
            .catch((e) => {
            that.snackbar.error(e.errorInfo || e.result || e.toString() || '设备状态修改失败');
            item.deviceIsUse = !item.deviceIsUse;
        });
    }
    async initUserList() {
        const that = this;
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
};
__decorate([
    Getter
], MaintainPlan.prototype, "deviceTypeList", void 0);
__decorate([
    Getter('deviceSerialList')
], MaintainPlan.prototype, "listSerial", void 0);
__decorate([
    Watch('planInfoDlg.form.lastMaintainTime')
], MaintainPlan.prototype, "onDialogLastMaintainTimeChanged", null);
MaintainPlan = __decorate([
    Component({
        name: 'MaintainPlan',
        components: {
            BcTable,
            BcDialog,
            BcSnackbar,
            BcMask,
        },
    })
], MaintainPlan);
export default MaintainPlan;
